export default "__VITE_ASSET__D00XyFdE__"